// extracted by mini-css-extract-plugin
export default {"root":"LoadingModal_root__gFEBp","txt":"LoadingModal_txt__l5Haj","ldsSpinner":"LoadingModal_ldsSpinner__A4d6D"};